/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Status_Failed_ShortInputs */

const vi_einvoice_status_failed_short = /** @type {(inputs: Einvoice_Status_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi xuất HĐ`)
};

/**

* @param {Einvoice_Status_Failed_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_status_failed_short = /** @type {((inputs?: Einvoice_Status_Failed_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Status_Failed_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_status_failed_short(inputs)
});